import { render, staticRenderFns } from "./CBoardLeft.vue?vue&type=template&id=78851f02&scoped=true&"
import script from "./CBoardLeft.vue?vue&type=script&lang=ts&"
export * from "./CBoardLeft.vue?vue&type=script&lang=ts&"
import style0 from "./CBoardLeft.vue?vue&type=style&index=0&id=78851f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78851f02",
  null
  
)

export default component.exports